<template>
  <section class="section section_bg custom_page_v2 first_page section_no_background"  >


    <div class="section_header mobile_div back_div_element" v-if="isload"   >
      <router-link tag="a" class="btn" :to="{name: 'setup_link'}"  ><i class="fa fa-backward"></i> Назад</router-link>

    </div>


    <loading-block v-if="isload==false" :loading="!isload"/>
    <card class="loading_div" v-if="isload==false">
      <h2>{{ load_message }}</h2>
    </card>

    <div class="" v-if="isload==true">
      <div class="section_header mobile_div nocenter">
        <tabs @tabchange="onTabChange" :activeTab="activeTab" :value="activeTab" fill class="flex-column flex-md-row tabs_style">
          <div class="mobile_div">
            <tab-pane title="setting">
            <span slot="title" class="tab_style">
                Настройка
            </span>
              <div class="container-fluid">


                <div class="col-12 " v-if="islogin==true">

                  <div class="row mt-2 mb-2">
                    <div class="col-12 col-sm-6">
                      <b class="shop_setting_title">Статус магазина</b>
                    </div>
                    <div class="col-12 col-sm-6">
                      <select class="form-control"  v-model="shop_setting['status']">
                        <option value="off">Выключен</option>
                        <option value="on">Включен</option>
                      </select>
                    </div>
                  </div>
                  <div class="row mt-2 mb-2">
                    <div class="col-12 col-sm-6">
                      <b class="shop_setting_title">Подтверждение заказа</b>
                    </div>
                    <div class="col-12 col-sm-6">
                      <select class="form-control"  v-model="shop_setting['accept_order']">
                        <option value="manual">Ручное</option>
                        <option value="auto">Автоматическое</option>
                      </select>
                    </div>
                  </div>
                  <div class="row mt-2 mb-2">
                    <div class="col-12 col-sm-6">
                      <b class="shop_setting_title">Название</b>
                    </div>
                    <div class="col-12 col-sm-6">
                      <input type="text" v-model="shop_setting['title']" class="form-control"/>
                    </div>
                  </div>
                  <div class="row mt-2 mb-2">
                    <div class="col-12 col-sm-6">
                      <b class="shop_setting_title">Описание</b>
                    </div>
                    <div class="col-12 col-sm-6">
                      <textarea v-model="shop_setting['description']" class="form-control text_rekv"></textarea>

                    </div>
                  </div>
                  <div class="row mt-2 mb-2">
                    <div class="col-12 col-sm-6">
                      <b class="shop_setting_title">Сообщение при выключеном состоянии</b>
                    </div>
                    <div class="col-12 col-sm-6">
                      <textarea v-model="shop_setting['error_message']" class="form-control text_rekv"></textarea>

                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-md-6 col-12 card section_no_background ">
                      <input type="checkbox" value="1" v-model="shop_setting['status_day1']"><b class="shop_setting_title">Понедельник</b>

                      <p>Время работы с <input type="time" v-model="shop_setting['day1']['start']"/></p>
                      <p>Время работы по <input type="time" v-model="shop_setting['day1']['end']"/></p>
                      <p>&nbsp;</p>
                    </div>

                    <div class="col-md-6 col-12 card  section_no_background">
                      <input type="checkbox" value="1" v-model="shop_setting['status_day2']"><b class="shop_setting_title">Вторник</b>

                      <p>Время работы с <input type="time" v-model="shop_setting['day2']['start']"/></p>
                      <p>Время работы по <input type="time" v-model="shop_setting['day2']['end']"/></p>
                      <p>&nbsp;</p>
                    </div>
                    <div class="col-md-6 col-12 card section_no_background">
                      <input type="checkbox" value="1" v-model="shop_setting['status_day3']"><b class="shop_setting_title">Среда</b>

                      <p>Время работы с <input type="time" v-model="shop_setting['day3']['start']"/></p>
                      <p>Время работы по <input type="time" v-model="shop_setting['day3']['end']"/></p>
                      <p>&nbsp;</p>
                    </div>
                    <div class="col-md-6 col-12 card section_no_background ">

                      <input type="checkbox" value="1" v-model="shop_setting['status_day4']"><b class="shop_setting_title">Четверг</b>

                      <p>Время работы с <input type="time" v-model="shop_setting['day4']['start']"/></p>
                      <p>Время работы по <input type="time" v-model="shop_setting['day4']['end']"/></p>
                      <p>&nbsp;</p>
                    </div>
                    <div class="col-md-6 col-12 card section_no_background ">
                      <input type="checkbox" value="1" v-model="shop_setting['status_day5']"><b class="shop_setting_title">Пятница</b>
                      <p>Время работы с <input type="time" v-model="shop_setting['day5']['start']"/></p>
                      <p>Время работы по <input type="time" v-model="shop_setting['day5']['end']"/></p>
                      <p>&nbsp;</p>
                    </div>
                    <div class="col-md-6 col-12 card section_no_background">
                      <input type="checkbox" value="1" v-model="shop_setting['status_day6']"><b class="shop_setting_title">Суббота</b>

                      <p>Время работы с <input type="time" v-model="shop_setting['day6']['start']"/></p>
                      <p>Время работы по <input type="time" v-model="shop_setting['day6']['end']"/></p>
                      <p>&nbsp;</p>
                    </div>
                    <div class="col-md-6 col-12 card section_no_background ">

                      <input type="checkbox" value="1" v-model="shop_setting['status_day7']"><b class="shop_setting_title">Воскресенье</b>

                      <p>Время работы с <input type="time" v-model="shop_setting['day7']['start']"/></p>
                      <p>Время работы по <input type="time" v-model="shop_setting['day7']['end']"/></p>
                      <p>&nbsp;</p>
                    </div>
                  </div>


                  <div class="row mt-2 mb-2">
                    <div class="col-12">
                      <button type="button" class="btn" @click="saveShopSetting()">Сохранить информацию</button>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane title="items">
            <span slot="title">

                Товары
            </span>
              <manage-items/>
            </tab-pane>


          </div>
        </tabs>


      </div>
    </div>

  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Modal from "@/components/Modal";
import Api from "@/models/Api";
import UserModel from "@/models/UserModel.js";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Tabs from "@/components/Tabs/Tabs";
import Tab from "@/components/Tabs/Tab";
import TabPane from "@/components/Tabs/TabPane";
import ManageItems from "./ManageItems";



export default {
  name: "Setting",

  data() {
    var app = this;
    return {
      "user":{},
      "islogin":false,
      "isload":false,
      "load_message":"Идет загрузка..",
      "iserror": false,
      "error_message": null,
      "shop_setting":null,
      'activeTab':"setting",

      data: [],
      selected: null,
      defaultOpenedDetails: [],
      showDetailIcon: true,



    }
  },

  mounted: function () {
    var app=this;
    if(app.$route.query && app.$route.query.tab_active ){
      app.activeTab=app.$route.query.tab_active;
    }
    app.setLoad();

    var user=UserModel.get();






    if(user && user.api_token){

      Api.ShopSettingGet(function(data){


        if(data.shop_setting==null){

          var new_shop_setting={};
          new_shop_setting["title"]="";
          new_shop_setting["description"]="";
          new_shop_setting["error_message"]="";
          new_shop_setting["status"]="off";
          new_shop_setting['status_day1']=true;
          new_shop_setting['status_day2']=true;
          new_shop_setting['status_day3']=true;
          new_shop_setting['status_day4']=true;
          new_shop_setting['status_day5']=true;
          new_shop_setting['status_day6']=true;
          new_shop_setting['status_day7']=true;
          new_shop_setting['day1']={"start":"10:00","end":"17:00"};
          new_shop_setting['day2']={"start":"10:00","end":"17:00"};
          new_shop_setting['day3']={"start":"10:00","end":"17:00"};
          new_shop_setting['day4']={"start":"10:00","end":"17:00"};
          new_shop_setting['day5']={"start":"10:00","end":"17:00"};
          new_shop_setting['day6']={"start":"10:00","end":"17:00"};
          new_shop_setting['day7']={"start":"10:00","end":"17:00"};
          data.shop_setting=new_shop_setting;
        }
        if(data.shop_setting && data.shop_setting['accept_order']){
          data.shop_setting['accept_order']="manual";
        }


        app.shop_setting=data.shop_setting;

        app.user=user;
        app.disableLoad();
        app.islogin=true;
      },function(error_message){


      })

    }














  },
  methods: {
    setLoad(message="Идет загрузка..."){
      var app=this;
      app.isload=false;
      app.load_message=message;

    },
    disableLoad(){
      var app=this;
      app.load_message="Идет загрузка";
      app.isload=true;
    },
    onTabChange(tab_active){
      this.activeTab=tab_active;
    },
    saveShopSetting(){

      var app=this;
      app.setLoad("Идет сохранение....");
      var json={};
      json["shop_setting"]=app.shop_setting;
      Api.ShopSettingSet(json,function(data){
        app.shop_setting=data.shop_setting;
        app.disableLoad();
      },function(error_message){

      });
    },


  },

  components: {Modal,ManageItems,LoadingBlock,Tabs,Tab,TabPane,}
};
</script>